import { formatNotificationTimeGroup, notificationIncludesMobile } from '@/helper/notificationHelper';

export default class NotificationItem {
  constructor(raw = {}, { mobile } = {}) {
    const source = raw || {};

    this.id = source._id || source.id || '';
    this.type =
      source.type ||
      source.notificationType ||
      source.eventType ||
      source.category ||
      source.subject ||
      'Notification';
    this.title =
      source.title ||
      source.notificationTitle ||
      '';
    this.body = source.body || source.message || source.description || '';
    this.createdAt = source.createdAt || source.created_at || source.updatedAt || source.updated_at || null;
    this.timeGroup = formatNotificationTimeGroup(this.createdAt);
    this.isRead = notificationIncludesMobile(source.readBy, mobile);
    this.raw = source;
  }
}
